import { Team as TeamModel } from '@web-portal/domains/shared/domain-models';

export class Team implements TeamModel {
  id = '';
  name = '';
  slug = '';
  isMyTeam = false;
}
